import { EntityWithIdAndDescription } from "../types/baseEntities";
import { CardTypeViewDTO } from "../types/purchaseOrder/Order";
import { httpClient } from "./client";

export interface AfipResponsableTipoVista extends EntityWithIdAndDescription {
    codDocumentoTipo?: number | null;
}

export const HttpCache = {
    getEndpoint: (url: string): string => `/cache${url}`,

    getProvincies: (): Promise<EntityWithIdAndDescription[]> =>
        httpClient.get<EntityWithIdAndDescription[]>(HttpCache.getEndpoint("/provincias")),

    getCities: (): Promise<EntityWithIdAndDescription[]> =>
        httpClient.get<EntityWithIdAndDescription[]>(HttpCache.getEndpoint("/localidades")),

    getCitiesByProvince: (provinceId: number): Promise<EntityWithIdAndDescription[]> =>
        httpClient.get<EntityWithIdAndDescription[]>(
            HttpCache.getEndpoint(`/localidades/${provinceId}`),
        ),

    getPersonTypes: (): Promise<EntityWithIdAndDescription[]> =>
        httpClient.get<EntityWithIdAndDescription[]>(HttpCache.getEndpoint("/persona-tipos")),

    getIdentityDocumentTypes: (): Promise<EntityWithIdAndDescription[]> =>
        httpClient.get<EntityWithIdAndDescription[]>(HttpCache.getEndpoint("/documento-tipos")),

    getTiposTarjeta: (): Promise<CardTypeViewDTO[]> =>
        httpClient.get<CardTypeViewDTO[]>(HttpCache.getEndpoint("/tarjeta-tipos")),

    getAfipResponsableTipos: (): Promise<AfipResponsableTipoVista[]> =>
        httpClient.get<AfipResponsableTipoVista[]>(
            HttpCache.getEndpoint("/afip-responsable-tipos"),
        ),
};
